import commonEnHK from './common_en-HK'

const kstEnHK = {
  kst: {
    ...commonEnHK,
  }
}

export default kstEnHK